<div class="p-grid" *ngIf="!update && getAnyData() !== null && getAnyData() !== undefined && getAnyData().toString() !== ''">
<div class="p-col-6">
  {{translation | translate}}
</div>
<div class="p-col-6">
  {{getAnyData()}}
</div>
</div>

<div class="p-grid" *ngIf="update && isDiff()">
  <div class="p-col-4">
    {{translation | translate}}
  </div>
  <div class="p-col-4">
    {{getDataByAttribute(oldData)}}
  </div>
  <div class="p-col-4">
    {{getDataByAttribute(newData)}}
  </div>
</div>
